<template>
    <div class="layout-right"ref="layout-right">
        <div class="layout-right-top">
            <right-top bread="系统设置-积分设置"></right-top>
        </div>
        <div class="layout-right-body">
            <el-tabs v-model="activeName">
                <el-tab-pane label="基本设置" name="BaseOption">
                    <score-base-option />
                </el-tab-pane>
                <el-tab-pane label="积分抵现" name="ScoreDeduct">
                    <score-deduct-option />
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import RightTop from "@/model/RightTop";
    import obj from "@/js/obj";
    import ScoreBaseOption from "@/model/Score/ScoreBaseOption";
    import ScoreDeductOption from "@/model/Score/ScoreDeductOption";
    export default {
        name: "ScoreOption",
        components: {ScoreDeductOption, ScoreBaseOption, RightTop},
        data: () => ({
            activeName: "BaseOption",
        }),
        mounted: function () {
            this.$store.commit("setMenuId", "7-3");
        },
        methods: {

        },
    }
</script>

<style scoped>
    .layout-right-body{
        margin: 16px;
        background-color: #FFFFFF;
    }

</style>
